import DotNet from '@/class/dotnet'

export default class Survey extends DotNet {

    constructor(httpClient: any) {

        super(httpClient)
    }

    convertTime12to24 = (time12h: string) => {
        const [time, modifier] = time12h.trim().split(' ');
      
        let [hours, minutes, seconds] = time.split(':');
      
        if (hours === '12') {
          hours = '00';
        }
      
        if (modifier) {
            if (modifier.toLowerCase() === 'pm') {
                const sum = parseInt(hours, 10) + 12;
                hours = '' + sum;
            }
        }
      
        return `${hours}:${minutes}:${seconds}`;
    }

    convertDate = (date: string) => {
        const [day, month, year] = date.split('/');

        return `${year}/${month}/${day}`;
    }

    post(data: any) {
        // sometimes we get no data here - TODO: investigate why
        if(!data) {
            // kludge to set the missing date
            // this probably won't be enough, object needs a survey id as well
            data = {
                surveyDate: new Date().toISOString()
            }
            // 2011-10-05T14:48:00
            data.surveyDate = data.surveyDate.substring(0, 19)
            // eslint-disable-next-line
            data.surveyDate = data.surveyDate.split('T').join(', ').replaceAll(/\-/g, '/')
        } else {
            // API v4 expects this in a specific format, so convert it
            if(data.surveyDate) {
                // not cool - "28/05/2019, 10:50:52 am"                
                let [date, time] = data.surveyDate.split(',');

                time = this.convertTime12to24(time);
                date = this.convertDate(date);

                // expected format is: YYYY/MM/dd, HH:mm:ss
                data.surveyDate = `${date}, ${time}`;
            }
        }
        return this.httpClient.post(this.survey, data)
    }

}
